'use strict';

export default class MultiStepsNav {
  constructor() {
    $('.js-display-summary').on('click', function (e){
    	e.preventDefault();

        let $this = $(this),
            $summary = $('.summary-dashboard'),
            $label = $('.show-summary__link-label');

        $this.toggleClass('active');

        if ($this.is('.active')) {
            $label.text('Hide summary');
        } else {
            $label.text('Show summary');
        }

        $summary.slideToggle();
    });
  }
}
